/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_User2Inputs */

const en_settings_reportingapikeys_generate_user2 = /** @type {(inputs: Settings_Reportingapikeys_Generate_User2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Settings_Reportingapikeys_Generate_User2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_user2 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_User2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_User2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_user2(inputs)
});
export { settings_reportingapikeys_generate_user2 as "settings_reportingApiKeys_generate_user" }